var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcReportTransactions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#D8F4E7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 13C18.48 13 14 17.48 14 23C14 28.52 18.48 33 24 33C29.52 33 34 28.52 34 23C34 17.48 29.52 13 24 13ZM24 31C19.59 31 16 27.41 16 23C16 18.59 19.59 15 24 15C28.41 15 32 18.59 32 23C32 27.41 28.41 31 24 31ZM27 17.5V20H23V22H27V24.5L30.5 21L27 17.5ZM21 21.5L17.5 25L21 28.5V26H25V24H21V21.5Z",
    fill: "#03A65B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcReportTransactions);
export default __webpack_public_path__ + "static/media/ic-report-transactions.cd5583a9.svg";
export { ForwardRef as ReactComponent };